/**
 * @generated SignedSource<<3849351cefc52bd6435a9d62b810d147>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionScoringCriteriaFragment$data = {
  readonly scoringCriteria: ReadonlyArray<{
    readonly description: string | null | undefined;
    readonly id: string;
    readonly title: string;
    readonly weight: number;
  }>;
  readonly slug: string;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentType": "CompetitionScoringCriteriaFragment";
};
export type CompetitionScoringCriteriaFragment$key = {
  readonly " $data"?: CompetitionScoringCriteriaFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionScoringCriteriaFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompetitionScoringCriteriaFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": "viewerCanEdit",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_COMPETITION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_COMPETITION\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompetitionScoringCriterion",
      "kind": "LinkedField",
      "name": "scoringCriteria",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "weight",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Competition",
  "abstractKey": null
};

(node as any).hash = "be9a94623e8a6848ff6a861ba1010149";

export default node;
